Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mutuallyExclusiveRequired = require('./mutuallyExclusiveRequired');

var _mutuallyExclusiveRequired2 = _interopRequireDefault(_mutuallyExclusiveRequired);

var _accessibilityLabel = require('./accessibilityLabel');

var _accessibilityLabel2 = _interopRequireDefault(_accessibilityLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = Object.assign({}, (0, _mutuallyExclusiveRequired2['default'])({
  accessibilityLabel: _accessibilityLabel2['default'],
  decorative: _propTypes2['default'].bool
}));


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/utils/propTypes/a11yIconProps.js
// module id = 446
// module chunks = 168707334958949